import { http, Result, querystring } from "@fider/services"
import { InAppFeedbackCatalog, InAppFeedbackIssue, InAppFeedbackIssueDetail, InAppFeedbackOverview, InAppFeedbackStatus } from "@fider/models"

export const getInAppFeedbackCatalog = async (feature?: string): Promise<Result<InAppFeedbackCatalog>> => {
  return await http.get<InAppFeedbackCatalog>(`/api/v1/inapp-feedback/catalog${querystring.stringify({ feature })}`)
}

export const getInAppFeedbackOverview = async (params: {
  feature?: string
  days?: number
  from?: string
  to?: string
  includeResolved?: boolean
}): Promise<Result<InAppFeedbackOverview>> => {
  return await http.get<InAppFeedbackOverview>(
    `/api/v1/inapp-feedback/overview${querystring.stringify({
      feature: params.feature,
      days: params.days,
      from: params.from,
      to: params.to,
      include_resolved: params.includeResolved ? "true" : undefined,
    })}`
  )
}

export const getInAppFeedbackIssue = async (slug: string, from?: string, to?: string): Promise<Result<InAppFeedbackIssueDetail>> => {
  return await http.get<InAppFeedbackIssueDetail>(`/api/v1/inapp-feedback/issues/${slug}${querystring.stringify({ from, to })}`)
}

export const setInAppFeedbackIssueStatus = async (slug: string, status: InAppFeedbackStatus): Promise<Result<InAppFeedbackIssue>> => {
  return await http.put<InAppFeedbackIssue>(`/api/v1/inapp-feedback/issues/${slug}/status`, { status })
}
